import { Map, List } from 'immutable'
import { getPmSectionProcessing, getPmSectionDone } from 'services/pm-section'
import { loadMoreSectionsStatus } from '../../entities'
import { selectSectionsIds } from '../common'

const getLoadMoreSectionsStatus = (state) => {
  const sectionIds = selectSectionsIds(state) || List()
  const { pmSection = Map() } = state
  const pmSectionList = pmSection.toList()
  const filteredSectionIds = sectionIds.reduce((acc, item) => {
    if (!pmSectionList.find((i) => i.getIn(['data', 'id']) === item)) {
      return acc
    }

    return acc.push(item)
  }, List())

  const currentSectionId = filteredSectionIds.last()

  const currentSectionLoaded = getPmSectionDone({
    pmSection,
    sectionId: currentSectionId,
  })

  const sectionsToLoadExist = filteredSectionIds.size !== sectionIds.size

  if (sectionsToLoadExist && currentSectionLoaded) {
    return loadMoreSectionsStatus.READY_TO_LOAD_MORE
  }

  return loadMoreSectionsStatus.EMPTY
}

export function selectHomeLoadMoreSections (state) {
  const sectionIds = selectSectionsIds(state)
  const { pmSection = Map() } = state
  const pmSectionList = pmSection.toList()
  const filteredSectionIds = sectionIds.reduce((acc, item) => {
    if (!pmSectionList.find((i) => i.getIn(['data', 'id']) === item)) {
      return acc
    }

    return acc.push(item)
  }, List())

  const status = getLoadMoreSectionsStatus(state)
  const nextSectionId = sectionIds.get(filteredSectionIds.size)

  const processing = getPmSectionProcessing({
    pmSection,
    sectionId: nextSectionId,
  })

  const totalCount = sectionIds.size
  const currentCount = filteredSectionIds.size
  return {
    status,
    currentCount,
    totalCount,
    processing,
    nextSectionId,
  }
}

export default selectHomeLoadMoreSections
